import { render, staticRenderFns } from "./NoDataMessage.vue?vue&type=template&id=87643ec0&scoped=true&"
import script from "./NoDataMessage.vue?vue&type=script&lang=js&"
export * from "./NoDataMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87643ec0",
  null
  
)

export default component.exports